module.exports = __webpack_public_path__ + "img/menu_contact-sharp.168cb7f0.svg";